// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.multiplex.RentalManagerUserPropertyMultiplexV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultiplexV2WebApiHandler_caption,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_delete,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_rank,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_update,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyMultiplexPhotoCaptionV2RequestDto,
  UserPropertyMultiplexPhotoDeleteV2RequestDto,
  UserPropertyMultiplexPhotoRankV2RequestDto,
  UserPropertyMultiplexPhotoResponseV2WebDto,
  UserPropertyMultiplexSetListingCriteriaResponseV2WebDto,
  UserPropertyMultiplexSetListingCriteriaV2RequestDto,
  UserPropertyMultiplexUpdateResponseV2WebDto,
  UserPropertyMultiplexUpdateV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Args {
  postData: UserPropertyMultiplexPhotoCaptionV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Options = UseMutationOptions<
  UserPropertyMultiplexPhotoResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Args
>;

/**
 * Update photo caption for every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexV2WebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Args) =>
      RentalManagerUserPropertyMultiplexV2WebApiHandler_caption(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Args {
  postData: UserPropertyMultiplexPhotoDeleteV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Options = UseMutationOptions<
  UserPropertyMultiplexPhotoResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Args
>;

/**
 * Delete a photo from every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyMultiplexV2WebApiHandler_delete(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Args {
  postData: UserPropertyMultiplexPhotoRankV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Options = UseMutationOptions<
  UserPropertyMultiplexPhotoResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Args
>;

/**
 * Update photo rank for every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexV2WebApiHandler_rank = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Args) =>
      RentalManagerUserPropertyMultiplexV2WebApiHandler_rank(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Args {
  postData: UserPropertyMultiplexSetListingCriteriaV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Options = UseMutationOptions<
  UserPropertyMultiplexSetListingCriteriaResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Args
>;

/**
 * Set listing criteria for all the units in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Args) =>
      RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Args {
  postData: UserPropertyMultiplexUpdateV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Options = UseMutationOptions<
  UserPropertyMultiplexUpdateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Args
>;

/**
 * Update listing fields for all the units in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexV2WebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Args) =>
      RentalManagerUserPropertyMultiplexV2WebApiHandler_update(args.postData, httpClient),
  });
};
